<main id="marketplace-home" *ngIf="!loading">
  <section class="m-b-2 pts-3">
    <app-banners displayAt="MARKETPLACE" />
  </section>

  <section class="pbs-3">
    <div class="category-wrapper">
      <div class="category-scrolls">
        <div
          *ngFor="let categorie of categories; let i = index"
          class="pointer-cursor"
          (click)="goToProducts('category', categorie)"
        >
          <div class="inline m-l-1 category-image">
            <img
              class="category-image {{ i % 2 === 0 ? '' : 'even' }}"
              [src]="categorie?.imageUrl ? categorie.imageUrl : '/assets/img/default-coupon.svg'"
              onerror="this.onerror=null; this.src='/assets/img/default-coupon.svg'"
              alt="Logo da loja"
            />
            <p class="category-name">
              {{ categorie?.label?.toUpperCase() }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="promotion-div desktop">
    <app-marketplace-promotion />
  </section>

  <section class="p-3">
    <div class="between">
      <h3>Mais procurados</h3>
      <div class="d-flex m-b-1 pointer-cursor" (click)="goToProducts('default')">
        <span class="see-more">Ver Mais</span>
        <img class="icon-chevron" alt="chevron-right" src="/assets/images/icons/chevron-right-primary.svg" />
      </div>
    </div>

    <div *ngIf="products.length" class="inline w-100 h-100">
      <nz-list nzGrid>
        <div nz-row [nzGutter]="{ xs: 8, sm: 8, md: 8, lg: 128, xl: 128, xxl: 8 }">
          <div
            class="m-b-1"
            nz-col
            [nzXs]="12"
            [nzSm]="12"
            [nzMd]="12"
            [nzLg]="4"
            [nzXl]="4"
            [nzXXl]="3"
            *ngFor="let item of products; let i = index"
          >
            <nz-list-item>
              <div class="product-card-marketplace" *ngIf="!item.loading">
                <app-product-card [product]="item" type="MARKETPLACE" (click)="goToProduct(item)"></app-product-card>
              </div>
              <div *ngIf="item.loading" class="product-card">
                <nz-skeleton [nzActive]="true" [nzLoading]="true" [nzAvatar]="{ size: 'large' }"> </nz-skeleton>
              </div>
            </nz-list-item>
          </div>
        </div>
      </nz-list>
    </div>
  </section>

  <section class="sponsor-div">
    <h3>Patrocinados</h3>
    <nz-row class="horizontal-scroll n-m-t-0">
      <nz-col nzSpan="24" class="w-100 d-flex">
        <nz-row class="w-100" nzGutter="16">
          <nz-col
            *ngFor="let sponsor of sponsors"
            [nzXs]="24"
            [nzSm]="24"
            [nzMd]="24"
            [nzLg]="8"
            [nzXl]="8"
            [nzXXl]="8"
            (click)="goToProducts('sponsors', sponsors)"
          >
            <nz-card [nzCover]="coverTemplate" class="pointer-cursor">
              <p class="sponsor-category-name">{{ sponsor.storeCategoryName }}</p>
              <p class="sponsor-store-name">Vendido por {{ sponsor.storeName }}</p>
            </nz-card>
            <ng-template #coverTemplate>
              <img
                class="sponsors-image"
                [src]="sponsor?.imageUrl ? sponsor.imageUrl : '/assets/img/default-coupon.svg'"
                onerror="this.onerror=null; this.src='/assets/img/default-coupon.svg'"
                alt="Logo da loja"
              />
            </ng-template>
          </nz-col>
        </nz-row>
      </nz-col>
    </nz-row>
  </section>

  <section class="p-3">
    <div class="between">
      <h3>Marcas</h3>
      <div class="d-flex pointer-cursor" (click)="goToBrands()">
        <span class="see-more">Ver Mais</span>
        <img class="icon-chevron" alt="chevron-right" src="/assets/images/icons/chevron-right-primary.svg" />
      </div>
    </div>

    <nz-row class="horizontal-scroll">
      <nz-col nzSpan="24" class="w-100 d-flex">
        <div *ngFor="let seller of sellers; let i = index">
          <div class="seller-div {{ i > 0 ? 'm-l-2' : '' }} pointer-cursor" (click)="goToProducts('seller', seller)">
            <img
              class="seller-img"
              [src]="seller?.image_url ? seller.image_url : '/assets/img/default-coupon.svg'"
              onerror="this.onerror=null; this.src='/assets/img/default-coupon.svg'"
              alt="Logo da loja"
            />
            <p class="seller-name">
              {{ seller?.business_name }}
            </p>
          </div>
        </div>
      </nz-col>
    </nz-row>
  </section>

  <section class="download-app-div desktop">
    <nz-row class="w-100">
      <nz-col nzSpan="12">
        <div class="download-app-info">
          <div class="info-content">
            <h2>Baixe nosso App</h2>
            <p class="m-b-2">Uma frase para descrever motivos para baixar nosso aplicativo</p>
            <a [href]="appDownloadUrl" class="m-t-0">
              <app-primary-button class="m-t-0" type="MARKETPLACE" [block]="true">
                Baixar nosso App
              </app-primary-button>
            </a>
          </div>
        </div>
      </nz-col>
      <nz-col nzSpan="12">
        <div class="download-app-image">
          <img src="/assets/images/download-app.png" alt="Imagem" />
        </div>
      </nz-col>
    </nz-row>
  </section>

  <section class="download-app-div mobile">
    <nz-row class="w-100">
      <nz-col nzSpan="24">
        <div class="download-app-image">
          <img src="/assets/images/download-app.png" alt="Imagem" />
        </div>
      </nz-col>
    </nz-row>

    <nz-row class="w-100">
      <nz-col nzSpan="24">
        <div class="download-app-info">
          <div class="info-content">
            <h2>Baixe nosso App</h2>
            <p class="m-b-2">Uma frase para descrever motivos para baixar nosso aplicativo</p>
            <a [href]="appDownloadUrl" class="m-t-0">
              <app-primary-button class="m-t-0" type="MARKETPLACE" [block]="true">
                Baixar nosso App
              </app-primary-button>
            </a>
          </div>
        </div>
      </nz-col>
    </nz-row>
  </section>

  <section class="promotion-div mobile">
    <app-marketplace-promotion />
  </section>
</main>

<div class="center m-t-2 m-b-2" *ngIf="loading">
  <nz-spin nzSize="large"></nz-spin>
</div>
